import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { SemesterForm } from "./-components/forms/semester-form";
import type { UpsertAdminSemesterDTO } from "@/orval/model";
import { useAdminSemesterCreateSemesterForOrganization } from "@/orval/admin-semester";
import { PortalPageHeader } from "@/components/portal-page-header";

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/semesters_/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { organizationId } = Route.useParams();
  const navigate = useNavigate();

  const { mutateAsync, isPending } = useAdminSemesterCreateSemesterForOrganization();

  const handleSubmit = async (data: UpsertAdminSemesterDTO) => {
    const semester = await mutateAsync({
      organizationId: organizationId,
      data,
    });

    navigate({
      from: Route.fullPath,
      to: "/organizations/$organizationId/admin/semesters/$semesterId",
      params: { organizationId, semesterId: semester.id },
      search: { tab: "class-days" },
    });
  };

  return (
    <div className="p-4 md:p-6">
      <PortalPageHeader
        className="mb-8"
        breadcrumbs={[
          { label: "Semesters", to: "/organizations/$organizationId/admin/semesters", params: { organizationId } },
          { label: "New Semester" },
        ]}
        title="New Semester"
      />

      <SemesterForm organizationId={organizationId} onSubmit={handleSubmit} isLoading={isPending} />
    </div>
  );
}
